import BaseSelect from './BaseSelect';

export default BaseSelect;

export { BaseSelect };
